<template>
  <section class="presentations">
    <slot name="before"></slot>
    <section class="presentations-list slider __slider">
      <Swiper :options="options">
        <SwiperSlide
          v-for="(presentation, index) in presentations"
          :key="index"
        >
          <router-link
            :to="`/presentation/${presentation.id}`"
            class="presentation-item flex flex-col gap-2"
          >
            <div class="img-wrapper">
              <img
                v-if="presentation.thumbnailImage || presentation.customThumbnailImage"
                :src="presentation.customThumbnailImage || presentation.thumbnailImage"
              >
              <img
                v-else
                src="@/assets/images/icon/default-thumbnail.svg"
              >
            </div>
            <h3 class="truncate">
              {{ presentation.name }}
            </h3>
            <aha-formatter
              :value="presentation.updatedAt"
              type="date"
              class="text-xs"
              :locale="locale"
            />
          </router-link>
        </SwiperSlide>
        <div class="swiper-nav-button next-presentation-btn" slot="button-next">
          <aha-icon
            name="chevron-right-2"
            width="8"
            viewBox="0 0 8 14"
          />
        </div>
        <div class="swiper-nav-button prev-presentation-btn" slot="button-prev">
          <aha-icon
            name="chevron-right-2"
            width="8"
            viewBox="0 0 8 14"
            class="transform rotate-180"
          />
        </div>
      </Swiper>
    </section>
    <slot name="after"></slot>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'PresentationsSectionV2',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    presentations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: {
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        noSwiping: false,
        cssMode: false,
        mousewheel: {
          forceToAxis: true,
        },
        spaceBetween: 16,
        navigation: {
          nextEl: '.next-presentation-btn',
          prevEl: '.prev-presentation-btn',
        },
        breakpoints: {
          768: {
            slidesPerGroup: 2,
          },
          960: {
            slidesPerGroup: 3,
          },
        },
      },
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.presenterLocale,
    }),
  },
}

</script>
<style lang="scss" scoped>
    .presentations {
        @apply rounded-lg shadow-card;
        display: flex;
        flex-direction: column;
        background-color: white;
        gap: 1rem;
        padding: 1rem;

        & > .presentations-list {
          .swiper-container {
            margin-left: auto;
            margin-right: auto;
            position: relative;
            overflow: hidden;
            list-style: none;
            padding: 2px;
            z-index: 1;
          }
          & .swiper-nav-button {
            --top-align: 28%;
            --padding-space: 0.5rem;
            position: absolute;
            z-index: 1;
            top: var(--top-align);

            &.swiper-button-disabled {
              display: none;
            }

            &.prev-presentation-btn {
              left: var(--padding-space);
            }

            &.next-presentation-btn {
              right: var(--padding-space);
            }
          }

          & .swiper-slide {
            width: 235px;

            & > *:last-child {
              margin-right: 1rem;
            }
          }

          & .presentation-item {
            --image-radius: 0.5rem;
            width: 100%;
            text-align: left;

            & img {
              width: 100%;
              aspect-ratio: 16 / 9;
              border-radius: var(--image-radius);
              object-fit: cover;
            }

            & > .img-wrapper {
                position: relative;
                &::after {
                  transition: opacity 0.15s;
                  @apply border-primary-90;
                  opacity: 0;
                  content: '';
                  position: absolute;
                  inset: 0;
                  border: 2px solid;
                  border-radius: var(--image-radius);
                  pointer-events: none;
                }
            }

            &:hover {
              & > .img-wrapper {
                &::after {
                  opacity: 1;
                }
              }

              & > * {
                @apply text-primary-90;
              }
            }

            &:focus-visible {
              border-radius: 0.5rem;
            }
          }
        }
    }
</style>
